import { render, staticRenderFns } from "./LeaveRequest.vue?vue&type=template&id=08946c6c&scoped=true"
import script from "./LeaveRequest.vue?vue&type=script&lang=js"
export * from "./LeaveRequest.vue?vue&type=script&lang=js"
import style0 from "./LeaveRequest.vue?vue&type=style&index=0&id=08946c6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08946c6c",
  null
  
)

export default component.exports